/**
 * The shell a pathname belongs to.
 *
 * TWO, not three, since vendor#137 retired the `/m/*` mobile shell: the
 * authenticated app is one responsive route set, and `(kiosk)` is the separate
 * anonymous-browse surface. `'mobile'` was removed from this union in the same
 * change — mobile is now a viewport, not a shell, and a `Shell` value that can
 * still be `'mobile'` would let per-shell branching (see `lib/pwaUpdate.ts`)
 * keep a dead arm that nothing can reach.
 *
 * The `(kiosk)` arm is a SECURITY boundary, not a layout choice — see the
 * ESLint import-boundary rule in `eslint.config.js` and the Vitest scan in
 * `shells/kiosk/__tests__/`. Retiring `/m/` collapsed two authenticated shells
 * into one; it did not touch this one.
 */
export type Shell = 'desktop' | 'kiosk';

export function detectShell(pathname: string): Shell {
  if (pathname.startsWith('/kiosk')) return 'kiosk';
  return 'desktop';
}
